import { create } from 'zustand';

interface SCState {
  scStandards: string[];
  setScStandards: (value: string[]) => void;
  editSCInfo: { scId?: string; isParentStatus?: boolean } | null;
  setEditSCInfo: (value: { scId?: string; isParentStatus?: boolean } | null) => void;
}

export const useScStore = create<SCState>((set) => ({
  scStandards: [],
  setScStandards: (value: string[]) => set({ scStandards: value }),
  editSCInfo: null,
  setEditSCInfo: (value) => set({ editSCInfo: value }),
}));